import { render, staticRenderFns } from "./TrainingCoursesEdit.vue?vue&type=template&id=de4c8d70&"
import script from "./TrainingCoursesEdit.vue?vue&type=script&lang=js&"
export * from "./TrainingCoursesEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports